export const WELCOME_SCREEN_CLOSE_DURATION = 600;
